import React from 'react';
import {Avatar, Typography, Tag} from 'antd';
import {TeamOutlined, WechatOutlined, TagOutlined} from '@/icons';
import UserExtLabel from '@/page/component/UserExtLabel';

const {Text} = Typography;
const columnDefines = () => ({
    customerAvatar: {
        title: '客户',
        dataIndex: 'customerAvatar',
        render: (text, record) => {
            const {customerName, corpName, type, customerAvatar} = record;
            let corp = type == 2 ? ' @' + corpName : '';
            return (
                <>
                    <Avatar src={customerAvatar} />
                    &nbsp;&nbsp;{customerName}
                    {record.realName && '(' + record.realName + ')'}
                    {/*<div>{record.externalUserid && '(' + record.externalUserid + ')'}</div>*/}
                    <Text style={{color: '#096dd9', fontSize: '12px'}}>{corp}</Text>
                </>
            );
        },
    },
    customerName: {
        title: '客户',
        dataIndex: 'customerName',
        render: (text, record) => <div>{record.realName}</div>,
    },
    identity: {
        title: '身份',
        dataIndex: 'identity',
    },
    extId: {
        title: '跟进员工编号',
        dataIndex: 'extId',
        render: extId => <>{extId.toUpperCase()}</>,
    },
    userName: {
        title: '跟进员工',
        dataIndex: 'userName',
        render: (text, record) => {
            return (
                <div>
                    {text}
                    <span>({record.extId})</span>
                </div>
            );
        },
    },
    gender: {
        title: '客户性别',
        dataIndex: 'gender',
        render: gender => (
            <>
                {gender === 0 && '未知'}
                {gender === 1 && '男'}
                {gender === 2 && '女'}
            </>
        ),
    },
    type: {
        title: '客户类型',
        dataIndex: 'type',
        render: type => {
            return type == 1 || type == 2 ? (
                <Tag
                    color={(type == 1 && 'green') || (type == 2 && 'blue')}
                    icon={(type === 1 && <WechatOutlined />) || (type == 2 && <TeamOutlined />)}
                >
                    {(type == 1 && '微信客户') || (type === 2 && '企业成员')}
                </Tag>
            ) : (
                ''
            );
        },
    },
    tags: {
        title: '标签',
        dataIndex: 'tagLinks',
        render: tagLinks => (
            <>
                {tagLinks.length > 0 &&
                    tagLinks.map(tag => {
                        return (
                            <Tag icon={<TagOutlined />} key={tag.id}>
                                {tag.tagName}
                            </Tag>
                        );
                    })}
            </>
        ),
    },
});

export function getColumns(
    keys = ['customerAvatar', 'userName', 'gender', 'type', 'tags', 'realName', 'identity']
) {
    const defines = columnDefines();
    return keys.map(key => defines[key]).filter(Boolean);
}
